export default __webpack_public_path__ + "f48dfba296a9e3e9da6cddbe0500b54d.png";